export default "__VITE_ASSET__9e534dbc__"